<template>
  <div class="container-fluid px-0">
    <div class="row">
      <dl class="col-12 m-auto details">
        <dt class="details__icon">
          <font-awesome-icon icon="user" />
        </dt>
        <dd class="details__description">
          {{ lead.enquiry.title }} {{ lead.enquiry.forename }} {{ lead.enquiry.surname }}
        </dd>
        <dt class="details__icon">
          <font-awesome-icon icon="phone" />
        </dt>
        <dd class="details__description">
          <a :href="'tel:' + lead.enquiry.telephone">{{ lead.enquiry.telephone }}</a>
        </dd>
        <dt class="details__icon">
          <font-awesome-icon icon="envelope" />
        </dt>
        <dd class="details__description">
          <a :href="'mailto:' + lead.enquiry.email">{{ lead.enquiry.email }}</a>
        </dd>
        <dt class="details__icon">
          <font-awesome-icon icon="map-marker-alt" />
        </dt>
        <dd class="details__description row">
          <div class="col-12">
            {{ lead.enquiry.address1 }}
          </div>
          <div v-if="lead.enquiry.address2" class="col-12">
            {{ lead.enquiry.address2 }}
          </div>
          <div class="col-12">
            {{ lead.enquiry.town }}<br>
          </div>
          <div class="col-12">
            {{ lead.enquiry.postcode }}
          </div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnquirerDetails",
  props:['lead']
}
</script>

<style scoped lang="scss">
.details {
  &__icon {
    width: 14px;
    margin-right: 25px;
    text-align: center;
    float: left;
  }

  &__description {
    width: calc(100% - 40px);
    float: left;
  }
}

</style>
